// MembershipWizard.jsx
import React, { useState } from 'react';
import WizardStep1 from './WizardStep1';
import WizardStep1a from './WizardStep1a';
import WizardStep1b from './WizardStep1b';
import WizardStep2 from './WizardStep2';
import WizardStep3 from './WizardStep3';


const MembershipWizard = ({ initialData = {}, isEdit = false, onClose, onSubmit }) => {
  const [step, setStep] = useState(1);
//  const [itemsList, setItemsList] = useState(initialData.membershipItems || []);

  const [formData, setFormData] = useState(initialData || {});
  const [itemsList, setItemsList] = useState([]);
  const [nextEnabled, setNextEnabled] = useState(false);

  const next = () => {
    if (step === 1) {
        // validate step 1 if needed
        setStep(2);
    } else if (step === 2) {
        // validate step 2 if needed
        setStep(3);
    } else if (step === 3) {
        // validate step 2 if needed
        setStep(4);
    } else if (step === 4) {
        // validate step 2 if needed
        setStep(5);
    } else if (step === 5) {
        // ✅ Save on final step
        handleFinalSubmit();
    }
  };

  const back = () => setStep(prev => Math.max(prev - 1, 1));

  const handleFormChange = (updatedData) => {
    setFormData({ ...formData, ...updatedData });
  };

  const enableNext = (enabled) => {
    setNextEnabled(enabled);
  }

  const handleFinalSubmit = () => {
    if (!formData.name || !formData.unitPrice || !formData.membershipType || !formData.membershipPeriodQty || !formData.membershipPeriodUnit) {
      alert("Please complete all required fields.");
      return;
    }
    if (itemsList.length === 0) {
      alert("Please add at least one item.");
      return;
    }
    onSubmit(formData, itemsList);
  };

  return (
    <div className="container p-4" style={{ padding: 'unset !important' }}>
      <div className="my-3">
        <strong>Step {step} of 5</strong>
      </div>

      {step === 1 && (
        <WizardStep1
          formData={formData}
          onChange={handleFormChange}
          enableNext={enableNext}
        />
      )}

      {step === 2 && (
        <WizardStep1a
          formData={formData}
          onChange={handleFormChange}
          enableNext={enableNext}
        />
      )}
      {step === 3 && (
        <WizardStep1b
          formData={formData}
          onChange={handleFormChange}
          enableNext={enableNext}
        />
      )}
      {step === 4 && (
        <WizardStep2
          formData={formData}
          itemsList={itemsList}
          onFormChange={handleFormChange}
          isEdit={isEdit}
          onClose={onClose}
          onSubmit={handleFinalSubmit}
          onItemsChange={(items) => setItemsList(items)} // <== capture from step 2
          enableNext={enableNext}
        />
      )}
      {step === 5 && (
        <WizardStep3
          formData={formData}
          itemsList={itemsList}
          onBack={back}
          onSubmit={handleFinalSubmit}
          onClose={onClose}
          enableNext={enableNext}
        />
      )}


        <div className="mt-4 d-flex justify-content-between align-items-center">
            {/* Left side: Back button */}
            {step > 1 ? (
                <button className="btn btn-secondary" onClick={back}>
                Back
                </button>
            ) : (
                <span />
            )}

            {/* Right side: conditional Next or Save/Cancel group */}
            {step < 5 ? (
                <button
                className="btn btn-primary"
                onClick={next}
                disabled={!nextEnabled}
                >
                Next
                </button>
            ) : (
                <div className="d-flex justify-content-end">
                <button
                    className="btn btn-success"
                    onClick={handleFinalSubmit}
                    disabled={!nextEnabled}
                >
                    {isEdit ? "Update" : "Save"}
                </button>
                <button className="btn btn-secondary ms-2" onClick={onClose}>
                    Cancel
                </button>
                </div>
            )}
        </div>



    </div>
  );
};

export default MembershipWizard;
